<template>
  <div class="community-industry">
    <el-card>
      <nav class="out">
        <nav class="input">
          <el-input v-model="search.keyword" size="medium" placeholder="行业名称" clearable />
        </nav>
        <nav class="input" style="width: 150px">
          <el-select v-model="search.status" placeholder="状态" size="medium" clearable>
            <el-option label="禁用" :value="0" />
            <el-option label="启用" :value="1" />
          </el-select>
        </nav>
        <nav class="input">
          <el-button size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="submitSearch">{{ btn ? '搜索' : 'loading..' }}</el-button>
          <el-button  type="primary" size="small" @click="openAdd">新增行业</el-button>
        </nav>
      </nav>
    </el-card>

    <el-card style="margin-top: 10px">
      <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
        <el-table-column prop="id" width="80" label="编号" />
        <el-table-column prop="name" label="行业名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status == 1" type="success" size="small">启用</el-tag>
            <el-tag v-else type="info" size="small">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" align="right" width="100">
          <template #header>
            <span>排序</span><br />
            <span style="font-size: 12px">（当前最大值：{{ orderMax }}）</span>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">数值越大，显示越靠前</div>
              <i class="el-icon-warning-outline" style="margin-left: 5px" />
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <template >
              <div class="input-box">
                <el-input
                  v-show="sortEditId === row.id"
                  v-model="row.sort"
                  size="small"
                  class="id"
                  @blur="handleSortBlur(row)"
                />
              </div>
              <span v-show="sortEditId !== row.id" class="el-icon-edit" @click="showSortInput(row.id)">
                {{ row.sort }}
              </span>
            </template>
            <!-- <span v-else>{{ row.sort }}</span> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="mini"
              class="skyblue"
              @click="openEdit(row)"
            >编辑</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              size="mini"
              class="red"
              @click="handleDelete(row.id)"
            >删除</el-button>
            <el-button
              type="text"
              size="mini"
              :class="row.status == 1 ? 'yellow' : 'green'"
              @click="handleStatus(row)"
            >{{ row.status == 1 ? '禁用' : '启用' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="search.page"
        background
        :page-size="search.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog :title="editId ? '编辑行业' : '新增行业'" :visible.sync="dialogVisible" width="500px" @closed="handleDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="行业名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入行业名称" />
        </el-form-item>
        <el-form-item v-if="!editId" label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CommunityIndustry',
  data() {
    return {
      btn: true,
      submitLoading: false,
      dialogVisible: false,
      editId: null,
      list: [],
      total: 0,
      orderMax: 0,
      sortEditId: null,
      search: {
        keyword: '',
        status: '',
        page: 1,
        pageSize: 10
      },
      queryParams: {},
      form: this.getDefaultForm(),
      rules: {
        name: [{ required: true, message: '请输入行业名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    getDefaultForm() {
      return {
        name: '',
        sort: 0
      }
    },
    rowClass() {
      return 'background:#F5F7FA;'
    },
    getQueryParams() {
      const params = {
        page: this.search.page,
        pageSize: this.search.pageSize
      }
      if (this.search.keyword) params.keyword = this.search.keyword
      if (this.search.status !== '' && this.search.status !== null && this.search.status !== undefined) {
        params.status = this.search.status
      }
      return params
    },
    getlist() {
      const params = Object.keys(this.queryParams).length ? { ...this.queryParams } : this.getQueryParams()
      this.$http
        .get('/admin/CommunityIndustry/getList', { params })
        .then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.list = res.data.list || []
            this.total = res.data.totalCount || 0
            this.orderMax = res.data.orderMax || 0
            this.btn = true
          }
        })
    },
    submitSearch() {
      if (!this.btn) return
      this.btn = false
      this.search.page = 1
      this.queryParams = this.getQueryParams()
      this.getlist()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.queryParams = {}
      this.getlist()
    },
    handleCurrentChange(page) {
      this.search.page = page
      this.queryParams = { ...this.getQueryParams(), page }
      this.getlist()
    },
    openAdd() {
      this.editId = null
      this.form = this.getDefaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    openEdit(row) {
      this.editId = row.id
      this.form = {
        name: row.name,
        sort: row.sort
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        const url = this.editId ? '/admin/CommunityIndustry/edit' : '/admin/CommunityIndustry/add'
        const payload = this.editId
          ? { id: this.editId, name: this.form.name }
          : { ...this.form }
        try {
          const { data: res } = await this.$http.post(url, payload)
          if (res.errorCode == 200) {
            this.$message.success(res.message)
            this.dialogVisible = false
            this.getlist()
          }
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleDialogClosed() {
      this.editId = null
      this.form = this.getDefaultForm()
    },
    handleDelete(id) {
      this.$confirm('此操作将永久删除该行业, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post('/admin/CommunityIndustry/del', { id }).then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.$message.success(res.message)
              if (this.total % this.search.pageSize == 1 && this.search.page > 1) {
                this.search.page--
                this.queryParams.page = this.search.page
              }
              this.getlist()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    handleStatus(row) {
      const status = row.status == 1 ? 0 : 1
      const actionText = status == 1 ? '启用' : '禁用'
      this.$confirm(`确认${actionText}该行业？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/admin/CommunityIndustry/updateStatus', { id: row.id, status })
            .then(({ data: res }) => {
              if (res.errorCode == 200) {
                this.$message.success(res.message)
                this.getlist()
              }
            })
        })
        .catch(() => {})
    },
    showSortInput(id) {
      this.sortEditId = id
      this.$nextTick(() => {
        $('.id input').focus()
      })
    },
    handleSortBlur(row) {
      this.$http
        .post('/admin/CommunityIndustry/sort', { id: row.id, sort: row.sort })
        .then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.$message.success(res.message)
            this.sortEditId = null
            this.getlist()
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.out {
  margin-bottom: 20px;
  .input {
    display: inline-block;
    margin-right: 20px;
  }
}
.skyblue {
  color: skyblue;
}
.green {
  color: green;
}
.red {
  color: red;
}
.yellow {
  color: #e6a23c;
}
</style>
